import { Box } from '@wix/design-system';
import React from 'react';
import { ResultsLayoutDataHooks } from './dataHooks';
const INLINE_PADDING = '48px';
const START_INLINE_PADDING = '24px';
export const VoucherRow = _ref => {
  let maxWidth = _ref.maxWidth,
    start = _ref.start,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? '0' : _ref$paddingTop,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? '0' : _ref$paddingBottom,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? 'SP2' : _ref$marginBottom,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: ResultsLayoutDataHooks.voucherRow,
    gridArea: "voucher",
    boxSizing: "border-box",
    position: "relative",
    align: "center",
    width: "100%",
    padding: `${paddingTop} ${INLINE_PADDING} ${paddingBottom} ${INLINE_PADDING}`,
    marginBottom: marginBottom
  }, start && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    insetInlineStart: START_INLINE_PADDING,
    height: "100%",
    verticalAlign: "middle"
  }, start), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    maxWidth: maxWidth
  }, children));
};
//# sourceMappingURL=VoucherRow.js.map